import styled from 'styled-components';
import Sale from './Sale';
import PaymentMethod from './PaymentMethod';
import Deductions from './Deductions';

const SalesOverview = () => {
  return (
    <Container>
      <Sale />
      <PaymentMethod />
      <Deductions />
    </Container>
  );
};

export default SalesOverview;

const Container = styled.div`
  display: flex;
  gap: 16px;
`;
